export const WEB_PORTAL_NEW_CALENDER_EXPERIMENT = 'web_new_calendar';
export const SAFE_MODE_LITE = 'safe-mode-lite';
export const DISPATCH_APP_CARD = 'dispatch-app-card';
export const PRICE_BOOK_MATERIAL = 'price-book-material';
export const VISUAL_PRICE_BOOK = 'visual-price-book';
export const ENABLE_HCP_ASSIST_PRODUCT_PAYWALL = 'enable-hcp-assist-product-pay-wall';
export const CALENDAR_V2_HIDE_ALLDAY_OVERLAY = 'calendar-v2-hide-all-day-overlay';
export const EMPLOYEE_CHAT_WEB = 'employee-chat-web';
export const CUSTOMER_CHAT_WEB = 'customer-chat-web';
export const PROCESS_SCHEDULED_PLAN_CHANGE_IMMEDIATELY_AS_ADMIN = 'process-scheduled-plan-change-immediately-as-admin';
export const SCHEDULE_CANCELLATIONS = 'schedule-cancellations';
export const STRIPE_CAPITAL_REFILL = 'stripe-capital-refill';
export const BENEFICIAL_OWNERS_FLOW = 'beneficial-ownership-flow';
export const IMPERSONATION_MODAL = 'impersonation-modal';
export const PREQUAL_ON_CUSTOMER_CREATION = 'prequal-on-customer-creation';
export const TIME_TRACKING_BY_TECH_RESET_EVENTS = 'time-tracking-by-tech-reset-events';
export const WISETACK_IMPROVED_EXPERIENCE_WEB = 'wisetack-improved-experience-web';
export const CALL_TRACKING_VERIFICATION_PROCESS = 'call-tracking-verification-process';
export const REQUEST_GUIDE_WIZARD = 'request-guide-wizard';
export const SERVICE_PLAN_DISCOUNTS_BACKFILL = 'service-plan-discounts-backfill';
